import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const styles = {
  usernameBox: {
    backgroundColor: (theme) => theme.palette.secondary.lightDisabled,
    padding: '28px 22px 35px',
  },
  button: {
    margin: '12px 0',
  },
}

export default function RSVPSignUp() {
  const navigate = useNavigate();

  return (
    <Box
      sx={styles.usernameBox}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Typography variant="h3" color="primary">
        Create a Username
      </Typography>
      <Button
        sx={styles.button}
        onClick={() => navigate(`/signup`)}
        variant="contained"
        fullWidth
        disableElevation
      >
        Sign-up
      </Button>
      <Typography variant="h4" color="primary">
        {"You're already halfway there."}
      </Typography>
    </Box>
  );
}
